export default __webpack_public_path__ + "static/media/070-pizza slice.dc056274.svg";